import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['input', 'item', 'empty', 'count'];

  connect() {
    this.filter();
  }

  filter() {
    const query = this.hasInputTarget ? this.inputTarget.value.trim().toLowerCase() : '';
    let visible = 0;

    this.itemTargets.forEach((element) => {
      const text = (element.dataset.searchText || '').toLowerCase();
      const matches = !query || text.includes(query);
      element.classList.toggle('hidden', !matches);
      if (matches) visible += 1;
    });

    if (this.hasEmptyTarget) {
      const showEmpty = query.length > 0 && visible === 0;
      this.emptyTarget.classList.toggle('hidden', !showEmpty);
    }

    if (this.hasCountTarget) {
      this.countTarget.textContent = String(visible);
    }
  }

  clear() {
    if (!this.hasInputTarget) return;

    this.inputTarget.value = '';
    this.filter();
    this.inputTarget.focus();
  }
}
